// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef17f14b","453":"e2e9cb61","455":"24532291","977":"7dea3e24"}[chunkId] + ".chunk.js";
};